export const smoothScroll = function smoothScroll(node, topOrLeft, horizontal) {
  return node.scrollTo({
    [horizontal ? 'left' : 'top']: topOrLeft,
    behavior: 'smooth'
  });
};

export default smoothScroll;
